import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import MobileMoney from "./MobileMoney";
import AddMobileMoney from "./AddMobileMoney";

export default function MobileMoneyIndex() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={MobileMoney} />
      <ProtectedRoute path={`${path}/add`} component={AddMobileMoney} />
    </Switch>
  );
}
